import React from "react";

function Footer() {
    return (
        <div className="footer">
            <div className="cright">
                <p>© Kow Cornelius 2023</p>
            </div>
            <div className="socials">
                <div><a target="_blank" href="https://www.facebook.com/kow.cornelius"><img src="./images/fb.jpg"/></a></div>
                <div><a target="_blank" href="https://www.youtube.com/@kowcornelius7056"><img src="./images/yt.jpg"/></a></div>
                <div><a target="_blank" href="https://gh.linkedin.com/in/kow-cornelius-0200454698"><img src="./images/in.jpg"/></a></div>
            </div>
        </div>
    );
}


export default Footer